import React, { useContext } from 'react'
import {
  PortalLayout,
  AngleNavbar,
  Logo,
  Button
} from 'react-angle-dashboard-components'
import { useHistory, useLocation, useParams } from 'react-router'
import { Paths } from '../../routes/paths'
import { useQuery } from 'react-query'
import { groupService } from '../../services'
import { AuthContext } from '../../context/Auth'

export const GroupAccessLayout: React.FC<{
  breadcrumbs?: any
  noMenu?: boolean
}> = ({ children, breadcrumbs, noMenu = false }) => {
  useContext(AuthContext)

  const { groupId } = useParams<{ groupId: string }>()
  const { data } = useQuery(['getGroup', groupId], () =>
    groupService.getGroupInfo(groupId)
  )

  const renwal = data?.in_renewal
  const history = useHistory()
  const location = useLocation()

  const isOnboardingCompleted =
    data?.onboarding_status === 'completed' ||
    data?.onboarding_status === 'under_review'

  // if onboarding is completed and no menu is false OR renewal is false and no menu is false

  const basePath = `/groups/${groupId}`
  const items =
    (isOnboardingCompleted && !noMenu) || (renwal && !noMenu)
      ? [
          {
            title: 'Summary',
            onClick: () => history.push(basePath + '/summary'),
            active: location.pathname.includes('/summary')
          },
          {
            title: 'Employees',
            onClick: () => history.push(basePath + '/employees'),
            active: location.pathname.includes('/employees')
          },
          {
            title: 'Billing',
            onClick: () => history.push(basePath + '/billing'),
            active: location.pathname.includes('/billing')
          },
          {
            title: 'Documents',
            onClick: () => history.push(basePath + '/documents'),
            active: location.pathname.includes('/documents')
          },
          {
            title: 'Reporting',
            onClick: () => history.push(basePath + '/reporting'),
            active: location.pathname.includes('/reporting')
          }
        ]
      : []

  return (
    <PortalLayout
      nav={
        <AngleNavbar
          items={items}
          logo={<Logo variant="simple" text="Business" />}
          avatar={
            <Button
              className="ml-4 text-nowrap"
              onClick={() => history.push(Paths.home)}
            >
              Back To Group List
            </Button>
          }
        />
      }
      breadcrumbs={breadcrumbs}
      noBreadcrumbs={!breadcrumbs}
    >
      {children}
    </PortalLayout>
  )
}
